export const setOrgListingConfig = (val) => ({
    type: 'SET_ORG_LISTING_CONFIG',
    val
});

export const updateOrgListingConfig = (val) => ({
    type: 'UPDATE_ORG_LISTING_CONFIG',
    val
});
